// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Admin panel  (small pieces shared by the Ratings & reviews and Testimonials screens)
// Star row (read-only, screen-reader text "4 out of 5 stars") and the round initials avatar (status text/colours live in utils/reviewsAdmin so this file only exports components). Tokens only (no hard-coded colours).
// Neighbours: pages/admin/AdminReviews, pages/admin/AdminTestimonials, utils/reviewsAdmin.
// ─────────────────────────────────────────────────────────────────────────────
import { Star } from "lucide-react";

export function Stars({ value, className = "" }: { value: number; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`}>
      <span className="sr-only">{value} out of 5 stars</span>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} aria-hidden="true" className={`h-4 w-4 ${n <= value ? "fill-teal-600 text-teal-600" : "text-ocean-900/25 dark:text-white/30"}`} />
      ))}
    </span>
  );
}

export function Avatar({ name, tone = "bg-ocean-700/10 dark:bg-white/10" }: { name: string; tone?: string }) {
  const letters = name.split(/\s+/).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "?";
  return <span aria-hidden="true" className={`flex h-10 w-10 flex-none items-center justify-center rounded-full text-sm font-bold ${tone}`}>{letters}</span>;
}
